import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getBarColors } from "./subcategoriesColors";

const BarChartCompetitorReview = ({
  data,
  seriesName,
  selectedColor,
  selectedSubCategory,
  setSubCategory,
}) => {
  const barColors = getBarColors();
  const graphData = Object.entries(data)
    .sort((a, b) => b[1] - a[1])
    .map(([name, y], index) => ({
      name,
      y,
      color: selectedSubCategory === name ? selectedColor : barColors[index],
      borderColor: selectedSubCategory === name ? "#481A6C99" : "unset",
      borderWidth: 2
    }));

  const onClickSubCatgory = (event) => {
    setSubCategory(event.point.name);
  };

  const getOptions = {
    chart: {
      type: "bar",
      animationLimit: 1000,
      scrollablePlotArea: {
        minHeight:
          graphData?.length < 8 ? 350 : graphData?.length < 16 ? 600 : 860,
        opacity: 1,
        scrollPositionY: 0,
      },
    },
    title: {
      text: "Sub Categories",
      align: "left",
      useHTML: true,
      style:{
        fontSize: "13px",

      }
    },
    exporting: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      valueSuffix: " %",
      outside: true
    },
    loading: {
      hideDuration: 1000,
      showDuration: 1000,
    },
    plotOptions: {
      bar: {
        borderRadius: "20%",
        dataLabels: {
          enabled: true,
          inside: false,
          useHTML: true,
        },
        groupPadding: 0.1,
      },
    },
    series: [
      {
        dataLabels: {
          enabled: true,
          inside: false,
          verticalAlign: "middle",
          format: "{point.y:.1f}%",
          style: {
            fontSize: "12px",
            fontWeight: 500,
            fontFamily: "Verdana, sans-serif",
          },
        },
        maxPointWidth: 30,
        selected: true,
        size: "98%",
        name: seriesName,
        data: graphData,
        events: {
          click: onClickSubCatgory,
        },
        colorByPoint: true,
        cursor: "pointer",
      },
    ],
    credits: {
      enabled: false,
    },
    xAxis: {
      type: "category",
      gridLineWidth: 0,
      labels: {
        align: "left",
        reserveSpace: true,
        style: {
          color: "#707070",
          fontSize: "13px",
          fontFamily: "Poppins",
          textTransform: "capitalize",
        },
      },
      lineColor: "#707070",
    },
    yAxis: {
      title: {
        text: "",
      },
      gridLineWidth: 0,
      labels: {
        format: "{value}%",
      },
      min: 0,
      max: graphData?.[0]?.y + 10,
      lineColor: "#707070",
      lineWidth: 1,
      showFirstLabel: false,
      showLastLabel: false,
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={getOptions} />
    </div>
  );
};

export default BarChartCompetitorReview;
